// extracted by mini-css-extract-plugin
export default {"cardWrapper":"styles_cardWrapper__Wg5io","title":"styles_title__hZ28n","cardBody":"styles_cardBody__gozDU","cardText":"styles_cardText__YLrFT"};